import React from 'react';
import { Form } from 'antd';
import UploadPhoto from '../../../../../../common/components/UploadPhoto/UploadPhoto';

const VehiclePhoto = ({ form, disabled, name, action, data }) => {
  const { getFieldDecorator, setFieldsValue } = form;
  return (
    <Form.Item>
      {getFieldDecorator(name, {
          valuePropName: 'image_url'
      })(
        <UploadPhoto
          disabled={disabled}
          name={name}
          data={data}
          form={form}
          action={action}
          update={file => setFieldsValue({ [name]: file })}
        />
      )}
    </Form.Item>
  );
};

export default VehiclePhoto;
